import { render, staticRenderFns } from "./AppUserDropdown.vue?vue&type=template&id=264844f8"
import script from "./AppUserDropdown.vue?vue&type=script&lang=js"
export * from "./AppUserDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports